var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 508 285.75",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern64",
    patternTransform: "scale(.3)",
    preserveAspectRatio: "xMidYMid",
    xlinkHref: "#pattern22"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern16",
    width: 102.04724,
    height: 102.04724,
    patternTransform: "scale(1)",
    patternUnits: "userSpaceOnUse",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102.05,
    height: 102.05,
    fill: "#bebebe"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern22",
    width: 102.04724,
    height: 102.04724,
    patternTransform: "scale(1)",
    patternUnits: "userSpaceOnUse",
    preserveAspectRatio: "xMidYMid"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.7795)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(.26458)",
    x: -5.371e-14,
    y: -5.371e-14,
    width: 102.05,
    height: 102.05,
    fill: "url(#pattern16)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 7.6262574,
    y: 22.945614,
    fill: "#9a9a9a",
    fontFamily: "Sans",
    fontSize: "26.458px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.646,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.6262574,
    y: 22.945614,
    fill: "#9a9a9a",
    fontSize: "26.458px",
    strokeWidth: 2.646
  }, "1")))))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -1.2434e-14,
    y: -1.0658e-14,
    width: 508,
    height: 285.75,
    fill: "#bebebe"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(.37795)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(.26458)",
    x: -5.371e-14,
    y: -5.371e-14,
    width: 102.05,
    height: 102.05,
    fill: "url(#pattern16)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 7.6262574,
    y: 22.945614,
    fill: "#9a9a9a",
    fontFamily: "Sans",
    fontSize: "26.458px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.646,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.6262574,
    y: 22.945614,
    fill: "#9a9a9a",
    fontSize: "26.458px",
    strokeWidth: 2.646
  }, "1"))), /*#__PURE__*/React.createElement("g", {
    transform: "scale(.37795)",
    display: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "scale(.26458)",
    x: -5.371e-14,
    y: -5.371e-14,
    width: 102.05,
    height: 102.05,
    fill: "url(#pattern16)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 7.6262574,
    y: 22.945614,
    fill: "#9a9a9a",
    fontFamily: "Sans",
    fontSize: "26.458px",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.646,
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.6262574,
    y: 22.945614,
    fill: "#9a9a9a",
    fontSize: "26.458px",
    strokeWidth: 2.646
  }, "1"))), /*#__PURE__*/React.createElement("rect", {
    transform: "scale(.37795)",
    x: -3.29e-14,
    y: -2.82e-14,
    width: 1344.1,
    height: 756.05,
    fill: "url(#pattern64)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg1);
export default __webpack_public_path__ + "static/media/bg_1.d26f2d28f79c1ccc6fc58b99c2dba9e7.svg";
export { ForwardRef as ReactComponent };